export default __webpack_public_path__ + "static/media/slide_10.7652ceaa.jpg";